function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { View } from "react-native";
import { Button } from "../Button";
import { NumberInput } from "../TextInput";
/**
 * An input field that allows entering a numeric value with helper buttons for
 * stepping the current value up/down.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-137}
 */ export var NumericStepperInput = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var initialValue = _param.value, onChangeValue = _param.onChangeValue, _param_min = _param.min, min = _param_min === void 0 ? 0 : _param_min, _param_max = _param.max, max = _param_max === void 0 ? 100 : _param_max, label = _param.label, ariaLabel = _param['aria-label'], testID = _param.testID, rest = _object_without_properties(_param, [
        "value",
        "onChangeValue",
        "min",
        "max",
        "label",
        'aria-label',
        "testID"
    ]);
    var value = initialValue !== null && initialValue !== void 0 ? initialValue : 0;
    var handleChange = function(newValue) {
        if (typeof newValue === 'number') {
            var clampedValue = Math.max(min, Math.min(max, newValue));
            onChangeValue(clampedValue);
        } else {
            onChangeValue(Math.max(min, 0));
        }
    };
    var decrement = function() {
        return handleChange(value - 1);
    };
    var increment = function() {
        return handleChange(value + 1);
    };
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 20
        },
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(Button, {
                onPress: decrement,
                "aria-label": "Decrease value",
                variant: "text",
                text: "",
                icon: "minus"
            }),
            /*#__PURE__*/ _jsx(NumberInput, _object_spread({
                style: {
                    width: 100
                },
                inputStyle: {
                    textAlign: 'center'
                },
                label: label,
                "aria-label": ariaLabel,
                value: value,
                onChangeValue: function(val) {
                    return handleChange(val);
                },
                testID: testID
            }, rest)),
            /*#__PURE__*/ _jsx(Button, {
                onPress: increment,
                "aria-label": "Increase value",
                variant: "text",
                text: "",
                icon: "plus"
            })
        ]
    });
});
